import Img from "./img";
import ProfilePhotoButton from "./profile-photo-button";
import { useUser, useUI, useNotifications } from "../contexts";
import UserAvatar from "./UserAvatar";
import NotifyBell from "./notify-bell";

const AccountButtons = () => {
	const { setLoginOpen, setNotificationDrawerOpen } = useUI();
	const { loggedIn } = useUser();
	const {
		unreadMessagesCount,
		unreadSalesCount,
		unreadPurchasesCount,
		unreadTransactionsCount,
		systemNoticesCount,
	} = useNotifications();

	const totalNoticeNum = unreadMessagesCount + unreadSalesCount + unreadPurchasesCount + unreadTransactionsCount + systemNoticesCount;



	return (
		<div className="account-buttons-cont">
				{loggedIn ? (
					<>
						<div
							className={`${
								totalNoticeNum > 0 ? "STATE--unread" : ""
							} notify-button`}
							onClick={() => {
								setNotificationDrawerOpen(true);
							}}
						>
							{totalNoticeNum > 0 && <div className="unreadCount">{totalNoticeNum}</div>}
							<NotifyBell />
						</div>
						<ProfilePhotoButton
							image={<UserAvatar size={38} />}
							unreadCount={totalNoticeNum}
						/>
					</>
				) : (
					<div onClick={() => setLoginOpen(true)}>
						<div className="login-signup-button">
							<Img
								className="svg"
								src="/images/svg/user-profile.svg"
							/>
						</div>
					</div>
				)}
		</div>
	);
};

export default AccountButtons;
